import React, { useState, useEffect } from 'react'
import '../Styles/Projects.css'
import Projectpop from '../components/Projectpop'
import axios from 'axios'
import { useNavigate } from 'react-router';
import Currency from '../components/Currency';
export default function Contracts() {
    const [data, setData] = useState([
        // { project_name: 'name1 VeryLongName', Agree_fee: 0, project_mebers: [], customer: 'name1 VeryLongName', flyxavi_approved_coast: 450, cur: 'INR', no_of_resources: 10, status: 'TODO' },
    ])
    const [temp,setTemp] = useState([
        { project_name: 'name1 VeryLongName', project_mebers: [], customer: 'name1 VeryLongName', flyxavi_approved_coast: 450, cur: 'INR', no_of_resources: 10, status: 'TODO' },
    ]);
    const check = async () => {
        let div1 = document.getElementById('optPnam').value;
        let div2 = document.getElementById('optPmem').value;
        let div3 = document.getElementById('optPAC').value;
        let div4 = document.getElementById('optRES').value;
        let div5 = document.getElementById('accomed').value;
        let query = {}
        query.consultant = div1.length == 0 ? 0 : parseInt(div1.split(' ').pop());
        query.assaigned_project = div2.length == 0 ? 0 : parseInt(div2.split(' ').pop());
        query.Agree_fee = div3.length == 0 ? 0 : div3.split(' ').pop();
        query.travel = div4;
        query.accomendation = div5
        var form_data = new FormData();
        for (var key in query) {
            form_data.append(key, query[key]);
        }
        if (div1 != '' || div2 != '' || div3 != '' || div4 != 'none' || div5 != 'none')
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/consultant/contract_module_filter/`,
                data: form_data,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(response => {
                console.log(div3.id)
                setData(response.data)
            }).catch(err => {
                let notify = document.getElementsByClassName('noti')[0];
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                ${err.response.data.message}
                            </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
            })
        else getContracts()
        setFil({
            consultant: div1.length == 0 ? null : 'consultant : ' + div1,
            assaigned_project: div2.length == 0 ? null : 'project name : ' + div2,
            Agree_fee: div3.length != 0 ? 'agreed fee lessthan : ' + div3 : null,
            travel: div4 != 'none' ? 'travel : ' + div4 : null,
            accomendation: div5 != 'none' ? 'accomedation : ' + div5 : null
        })
    }
    function TabRen() {
        const list=[]
        for (let i = 0; i < 20; i++) {
            list.push(
                <tr>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                </tr>
            )
        }
        return (
            <>
                {list}
            </>
        )
    }
    const getContracts = async (bol) => {
        // console.log(this.props)
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'CONSULTANT' ? 'consultant/contract/':type == 'HR' ? 'hr/contract/':'consultant/contract/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                setboler(true)
                setTemp([...response.data]);
                // for (var option of document.getElementById("curselect").options) {
                //     if (option.value === curcur) {
                //         option.selected = true;
                //         break;
                //     }
                // }
                // let currency = JSON.parse(localStorage.getItem('currency'))
                setData(response.data.map((e) => {
                    if (bol) {
                        document.getElementById('Cnames').innerHTML += `<option value='${e.consultant_name + ' - id ' + e.consultant}'/>`
                        document.getElementById('Pnames').innerHTML += `<option value='${e.assaigned_project_name + ' - id ' + e.assaigned_project}'/>`
                        document.getElementById('AFfee').innerHTML += `<option value='${e.Agree_fee}'/>`
                    }
                    // let dat = Object.assign({}, e)
                    // dat.Agree_fee = parseFloat((dat.Agree_fee / currency[curcur]).toFixed(2));
                    // console.log(dat)
                    return e
                }))
            }).catch(err => {
                let notify = document.getElementsByClassName('noti')[0];
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                ${err.response.data.message}
                            </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
            })

        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'CONSULTANT' ? 'consultant/projects/':type == 'HR' ? 'hr/projects/':'project/projects/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                await response.data.map(async(e) => {
                    document.getElementById('projdrop').innerHTML +=
                        `<option value='${e.id}'>${e.project_name}</option>`
                })
                // setselOpP(response.data)
                setLoad(false)
            }).catch(err => {
                console.log(err)
                setLoad(false)
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
            })
    }
    const [SelOpP,setselOpP]=useState([])
    function clear(id) {
        if (id == 'optPnam' || id == 'optPmem' || id == 'optPAC') {
            document.getElementById(id).value = ''; check(); return;
        }
        var elements = document.getElementById(id).options;
        for (var i = 0; i < elements.length; i++) {
            elements[i].selected = false;
        }
        check();
    }
    useEffect(async () => {
        if (!curcur) { curcur = 'INR'; localStorage.setItem('selectedCurrency', 'INR') }
        if (!symbol) { setSymbol('/-'); localStorage.setItem('symbol', '/-') }
        await getContracts(true)
    }, [])
    let navigate = useNavigate();
    const Filtertag = (e) => {
        return <div className='filterBox'>
            {e.name}
            <i style={{ cursor: 'pointer' }} onClick={() => { clear(e.id) }} class="fas fa-times"></i>
        </div>
    }
    const [filters, setFil] = useState({})
    const curCall = () => { }
    const [booler, setboler] = useState(false)
    var curcur = localStorage.getItem('selectedCurrency')
    const [symbol, setSymbol] = useState(localStorage.getItem('symbol'))
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let type=localStorage.getItem('type');
    const [load,setLoad]=useState(true)
    return (
        type=='HR'||type=='CONSULTANT'?<>
            <div className='showdet'>
                <div className='sticky'></div>
                <div className='sticky2'>
                {type=='HR'?<Projectpop ProjDat={setselOpP} callBack={getContracts} data={null} path='contracts' />:<></>}
                </div>
            </div>
            {booler ? <Currency symbol={setSymbol} callback={curCall} for='contracts' ad={temp} data={data} setData={setData} /> : <></>}
            <div className='showdet filter showfil'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    <div className='projDetI inputfix Projects'>
                        <i onClick={() => {
                            // document.getElementsByClassName('showfil')[0].style.display = 'none' }} 
                            document.getElementsByClassName('showfil')[0].classList.remove('show_hide')
                        }}
                            style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                        <div> <span>Consultant  </span>
                            {/* <select id='optPnam'>
                                <option value="none">SELECT</option>
                            </select> */}
                            <input id='optPnam' list='Cnames' placeholder='type...' />
                            <datalist id="Cnames">

                            </datalist>
                        </div>
                        <div> <span>Project Assigned  </span>
                            {/* <select id='optPmem'>
                                <option value="none">SELECT</option>
                            </select> */}
                            <input id='optPmem' list='Pnames' placeholder='type...' />
                            <datalist id="Pnames">

                            </datalist>
                        </div>
                        <div> <span>Agreed Fees less than </span>
                            {/* <select id='optPAC'>
                                <option value="none">SELECT</option>
                            </select> */}
                            <input id='optPAC' list='AFfee' placeholder='type...' />
                            <datalist id="AFfee">

                            </datalist>
                        </div>
                        <div> <span>Travel  </span>
                            <select id='optRES'>
                                <option value="">SELECT</option>
                                <option value="yes">YES</option>
                                <option value="no">NO</option>
                            </select>
                        </div>
                        <div> <span>Accomodations  </span>
                            <select id='accomed'>
                                <option value="">SELECT</option>
                                <option value="yes">YES</option>
                                <option value="no">NO</option>
                            </select>
                        </div>
                        <button className='filter-apply' onClick={() => { check(); document.getElementsByClassName('showfil')[0].classList.remove('show_hide') }}> Apply </button>

                    </div>
                </div>
            </div>
            <div className='Projects top'>
                <div className='ProjectsTop row'>
                    <div className="projleft">CONTRACTS</div>
                    <div className="projright row">
                        {type=='HR'?<button onClick={() => document.getElementsByClassName('showdet')[0].classList.add('show_hide')} >CREATE</button>:<></>}
                        <div onClick={() => document.getElementsByClassName('showfil')[0].classList.add('show_hide')} className='column'>
                            <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                {/* <div className='filterList'>
                    <div className='filterBox'>TODO<i onClick={() => document.getElementById('onecheck').value = false} class="fas fa-times"></i></div>
                </div> */}
                <div className='filterList'>
                    {filters.consultant && <Filtertag name={filters.consultant} id='optPnam' />}
                    {filters.assaigned_project && <Filtertag name={filters.assaigned_project} id='optPmem' />}
                    {filters.Agree_fee && <Filtertag name={filters.Agree_fee} id='optPAC' />}
                    {filters.travel && <Filtertag name={filters.travel} id='optRES' />}
                    {filters.accomendation && <Filtertag name={filters.accomendation} id='accomed' />}
                </div>
                <div>
                    <table>
                        <tr>
                            <th>CONSULTANT</th><th>PROJECT ASSIGNED</th><th>AGREED FEES
                            <span onClick={() => {
                                document.getElementsByClassName('currency')[0].classList.add('show_hide')
                            }
                            } style={{ cursor: 'pointer' }}>
                                <i class="fas fa-ellipsis-v"></i></span>
                            </th><th>TRAVEL</th><th>ACCOMENDATIONS</th>
                        </tr>
                        {!load? data.map((dat) => {
                            return <tr onClick={() =>{localStorage.setItem(`contract-${dat.slug}`, JSON.stringify(dat) ); navigate(`/ContractDetails/${dat.slug}`)}}>
                                <td>{dat.consultant_name}</td><td >{dat.assaigned_project_name}</td>
                                <td>{numberWithCommas(dat.Agree_fee)+dat.currency}</td><td>{dat.travel ? 'Yes' : 'No'}</td><td>{dat.accomendation ? 'Yes' : 'No'}</td>
                            </tr>
                        }):<><TabRen/></>}
                    </table>
                </div>
            </div>
        </>:<></>
    )
}
